import { memo } from 'react';

interface VerificationChoiceModalProps {
  email: string;
  phoneNumber: string;
  isAccountCreation?: boolean;
  onChoosePhone: () => void;
  onChooseEmail: () => void;
}

const maskPhone = (phone: string) => {
  const digits = phone.replace(/\D/g, '');
  const last4 = digits.slice(-4) || phone;
  return `*** *** ${last4}`;
};

export const VerificationChoiceModal = memo(
  ({email, phoneNumber, onChoosePhone, onChooseEmail}: VerificationChoiceModalProps) => {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4">
        <div className="w-full max-w-xl rounded-lg bg-white p-6 text-black shadow-xl">
          <h2 className="text-2xl font-semibold text-center">
            Verify your account
          </h2>
          <p className="mt-2 text-sm text-center text-gray-700">
            Please verify your account. We will send a verification code via SMS or email to {email}.
          </p>
          <div className="mt-6 flex flex-col gap-3">
            <button
              className="w-full text-base rounded-md bg-primary py-3 text-white font-semibold disabled:opacity-60"
              onClick={onChoosePhone}
            >
              Send via SMS to {maskPhone(phoneNumber)}
            </button>
            <button
              className="w-full text-base rounded-md bg-primary py-3 text-white font-semibold disabled:opacity-60"
              onClick={onChooseEmail}
            >
              Send code via email
            </button>
          </div>
        </div>
      </div>
    );
  }
);

VerificationChoiceModal.displayName = 'VerificationChoiceModal';
